function downloadString(text, fileType, fileName) {
  let blob = new Blob([text], {type: fileType});
  let a = document.createElement('a');
  a.download = fileName;
  a.href = URL.createObjectURL(blob);
  a.dataset.downloadurl = [fileType, a.download, a.href].join(':');
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(function () {
    URL.revokeObjectURL(a.href);
  }, 1500);
}

function convertCSV(objArray) {
  let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
  let str = '';

  // Set Header
  let line = '';
  for (const [key, value] of Object.entries(array[0])) {
    if (line !== '') line += ',';
    line += key;
  }
  str += line + '\r\n';

  for (let i = 0; i < array.length; i++) {
    line = '';
    for (let index in array[i]) {
      if (line !== '') line += ','
      line += array[i][index];
    }

    str += line + '\r\n';
  }

  return str;
}

export default function download(object, fileName) {
  let csvData = convertCSV(object)
  downloadString(csvData, 'text/csv', fileName)
}
